import type Prompt from "~/components/v2/coupon/Prompt.vue";

export enum GoogleAnalyticsEvent {

    /* ========== PAGE VIEW ======== */
    PAGE_VIEW = 'page_view_event',
    PLP_VIEW = 'plp_view',
    CLP_VIEW = 'clp_view',
    PDP_VIEW = 'pdp_view',
    SLP_VIEW = 'slp_view',

    /* ========== POP UP VIEW ======== */
    POP_UP_VIEW = 'pop_up_view',
    POP_UP_CLICK = 'pop_up_click',
    POP_UP_CLOSE = 'pop_up_close',

    PAGE_SCROLL = 'page_scroll',

    COMPONENT_IMPRESSION = 'component_impression',

    LOGIN_EVENT = 'login_event',

    /* ============ CTA ============ */
    CTA_CLICK = 'cta_click',
    COMPONENT_CLICK = 'component_click',
    COMPONENT_ITEM_CLICKED = 'component_item_clicked',
    BACK_BUTTON_EVENT = 'back_button_event',
    COMPONENT_EVENT = 'component_event',

    /* =========== SEARCH ========== */
    SEARCH_OPEN = 'search_open',
    SEARCH = 'search',
    SEARCH_PERFORMED = 'search_performed',
    VIEW_SEARCH_RESULTS = 'view_search_results',
    SEARCH_SUGGESTION_CLICKED = 'search_suggestion_clicked',

    /* ========= USER FLOW ========= */
    RATING_POPUP_VIEW = 'rating_popup_view',
    ERROR_POPUP_SHOW = 'error_popup_show',
    TOAST_SHOW = 'toast_show',
    

    /* ======= IMAGE UPLOAD ======== */
    IGM_UPLOAD = 'igm_upload',
    IGM_REMOVE_UPLOAD = 'igm_remove_upload',
    IGM_UPLOAD_SUCCESS = 'igm_upload_success',
    IGM_UPLOAD_ERROR = 'igm_upload_error',
    IGM_UPLOAD_ERROR_COUNT = 'igm_upload_error_count',

    /* ===== LOCATION SELECTION ==== */
    SELECT_LOCATION_SCREEN = 'select_location_screen',
    LOCATION_CHANGE_CONFIRMATION_POPUP = 'location_change_confirmation_popup',

    /* ========= CART FLOW ========= */
    CART_API_CALL = 'cart_api_call',

    ADD_TO_CART = 'add_to_cart',          // GA4 standard
    REMOVE_FROM_CART = 'remove_from_cart',// GA4 standard
    VIEW_CART = 'view_cart',              // GA4 standard
    BEGIN_CHECKOUT = 'begin_checkout',    // GA4 standard

    /* ========= PAYMENT FLOW ====== */
    PAYMENT_CANCELLED = 'payment_cancelled',
    PAYMENT_FAILED = 'payment_failed',
    PAYMENT_SUCCESS = 'payment_success',

    /* ======== ORDER FLOW ========= */
    PURCHASE = 'purchase',                // GA4 standard
    ORDER_FAILED = 'order_failed',
    ORDER_CONFIRMED = 'order_confirmed',
    ORDER_PENDING = 'order_pending',
    ORDER_UNKNOWN = 'order_unknown',

    /* ======== LOCATION FLOW ========= */
    CHECK_LOCATION_PERMISSION = 'check_location_permission',
    LOCATION_PERMISSION_PROMPT = 'location_permission_prompt',
    LOCATION_PERMISSION_GRANTED = 'location_permission_granted',
    LOCATION_PERMISSION_DENIED = 'location_permission_denied',
    LOCATION_UPDATED = 'location_updated',
    ADDRESS = 'address',
    LOCATION = 'location',
    
}


export enum GoogleEventAction {
    VIEW = 'view',
    CLICK = 'click',
    SCROLL = 'scroll',
    SEARCH = 'search',
    UPLOAD = 'upload',
    API_CALL = 'api_call',
    PURCHASE = 'purchase',
    CHECK = 'check',
    PROMPT = 'prompt'
}


export enum EventCTANames {
    LOCATION_CTA_CLICKED = 'delivery_location_cta',
    HEADER_LOGO = 'header_logo',
    PROFILE_CTA = 'profile_cta',
    CLEAR_SEARCH = 'clear_search',
    TRENDING_SEARCHES = 'trending_searches',
    RECENT_SEARCHES = 'recent_searches',
    CLEAR_ALL = 'clear_all',
    SEARCH_PROVIDER_CTA = 'search_provider_cta',
    SEARCH_PRODUCT_CTA = 'search_product_cta',
}



export enum EventParameter {
    /* Generic */
    CTA_NAME = 'cta_name',
    CTA_LABEL = 'cta_label',
    LABEL_DATA = 'label_data',
    LABEL_SKU = 'label_sku',
    PLACEMENT = 'placement',
    PAGE_PATH = 'page_path',
    PAGE_CATEGORY = 'page_category',
    EVENT_CATEGORY = 'event_category',
    EVENT_LABEL = 'event_label',
    LABEL = 'label',
    VALUE = 'value',
    CURRENCY = 'currency',
    CLICK_SCOPE = 'click_scope',
    COMPONENT_NAME = 'component_name',
    COMPONENT_ID = 'component_id',
    COMPONENT_TYPE = 'component_type',
    BANNER_ID = 'banner_id',
    BANNER_POSITION = 'banner_position',
    LAYOUT_NAME = 'layout_name',
    SOURCE = 'source',
    LAYOUT_POSITION = 'layout_position',
    TARGET_URL = 'target_url',
    REDIRECTION_TYPE = 'redirection_type',
    ITEM_TITLE = 'item_title',
    ITEM_ID = 'item_id',
    ITEM_QUANTITY = 'item_quantity',
    ITEM_DENOMINATION = 'item_denomination',
    CLICKED_SUGGESTION = 'clicked_suggestion',
    RESULT_POSITION = 'result_position',
    SEARCH_INITIATED = 'search_initiated',
    LAST_SCROLL_POSITION = 'last_scroll_position',
    ACTION = 'action',
    STATUS = 'status',  

    /* Scroll */
    PERCENT_SCROLL = 'percent_scroll',

    /* Search */
    SEARCH_QUERY = 'search_query',
    SEARCH_SUGGESTION_CLICKED = 'search_suggestion_clicked',
    SEARCH_RESULT_STATUS = 'search_result_status',
    NO_OF_SEARCH_RESULTS = 'no_of_search_results',
    SEARCH_RESULT_TIME_MS = 'search_result_time_ms',
    SEARCH_SCOPE = 'search_scope',
    SEARCH_PERFORMED_SCREEN = 'search_performed_screen',
    SEARCH_RESULT_COUNT = 'search_result_count',
    CATEGORIES_COUNT = 'categories_count',
    PROVIDERS_COUNT = 'providers_count',
    PRODUCTS_COUNT = 'products_count',
    SEARCH_ITEMS = 'search_items',

    /* Product */
    PRODUCT_NAME = 'product_name',
    PRODUCT_SKU = 'product_sku',
    CATEGORY_NAME = 'category_name',
    PARENT_CATEGORY_NAME = 'parent_category_name',
    SUB_CATEGORY_NAME = 'sub_category_name',

    /* Gift Card */
    GIFT_CARD_NAME = 'gift_card_name',
    GIFT_CARD_ID = 'gift_card_id',

    /* Provider */
    PROVIDER_NAME = 'provider_name',
    PROVIDER_UKID = 'provider_ukid',

    /* Cart & Order */
    ORDER_ID = 'order_id',
    ONDC_ORDER_ID = 'ondc_order_id',
    TRANSACTION_ID = 'transaction_id',
    CART_VALUE = 'cart_value',
    ORDER_STATUS = 'order_status',
    ITEMS = 'items',
    ORDER_TYPE = 'order_type',
    RAZORPAY_ORDER_ID = 'razorpay_order_id',
    RAZORPAY_PAYMENT_ID = 'razorpay_payment_id',

    /* Payment */
    PAYMENT_TYPE = 'payment_type',
    EXIT_METHOD = 'exit_method',

    /* Errors */
    ERROR_MESSAGE = 'error_message',
    ERROR_CODE = 'error_code',
    API_RESPONSE = 'api_response',

    /* Upload */
    FILE_NAME = 'file_name',
    UPLOADED_IMAGES_COUNT = 'uploaded_images_count',
    UPLOAD_ERROR_COUNT = 'upload_error_count',

    /* Pop Up */
    POP_UP_NAME = 'pop_up_name',
    POP_UP_TITLE = 'pop_up_title',
    POP_UP_CTA_NAME = 'pop_up_cta_name',


    /* Misc */
    CONTACT_VALUE = 'contact_value',
    FILTER_DATA = 'filter_data',
    REFFERER = 'referrer',
    SHARE_URL = 'share_url',
    COUPON_CODE = 'coupon_code',
    COUPON_STATUS = 'coupon_status',
    TOAST_MESSAGE = 'toast_message',

    TICKET_ID = 'ticket_id',
    RAISE_REQUEST_CATEGORY = 'raise_request_category',
    RAISE_REQUEST_ISSUE_CATEGORY = 'raise_request_issue_category',
    RAISE_REQUEST_ISSUE_SUB_CATEGORY = 'raise_request_issue_sub_category',

    /* Location */
    LATITUDE = 'latitude',
    LONGITUDE = 'longitude',
    ADDRESS = 'address',
    LOCATION_AVAILABLE = 'location_available',
    REASON = 'reason',
    PROMPT_TYPE = 'prompt_type',
    NEEDS_LOCATION_FETCH = 'needs_location_fetch'


    
}

export enum EventParameterValue {
    HEADER = 'header',
    CATEGORY_SCREEN = 'category_screen',
    HOME_SCREEN = 'home_screen'
}

export enum EventStatus {
    IN_PROGRESS = 'in_progress',
    SUCCESS     = 'success',
    FAILED      = 'failed',
    ABANDONED    = 'abandoned',
}